<template>
  <div>
    <b-card>
      <b-row class="pt-2">
        <b-col sm="10">
          <h3>OBJETIVO PRIORITARIO GENERAL DEL 2021 - 2030</h3>
        </b-col>
        <!-- <b-col
          sm="2"
          style="text-align: right"
        >
          <b-form-select
            v-model="selected"
            :options="optionsPeriodo"
          />
        </b-col> -->
      </b-row>
    </b-card>
    <b-row sm="12">
      <b-col
        v-for="(objetivo,index) in items.avanceObjetivo"
        :key="objetivo.tipoObjetivoId"
        md="4"
        sm="4"
        class="centrate mt-2 mb-2  pr-4 pl-4 match-height"
        @click="objetivoDetalle(objetivo.tipoObjetivoId)"
      >
        <b-card :style="`border: 4px solid ${chartColor[index]}!important;border-radius: 16px;padding: 0.01em 16px;`">
          <div>
            <h3>OP{{ index+1 }}</h3>
            <b-img
              style="width:80px;height:80px;"
              :src="require(`@/assets/images/prcp/op${index+1}.png`)"
            />
            <b-col>
              <h4>
                <strong>{{ objetivo.descripcion }} </strong>
              </h4>
              <small>Conductor : {{ objetivo.representante.conductor.descripcion }}</small>
            </b-col>
            <b-col>
              <!-- <vue-apex-charts
              type="radialBar"
              height="70"
              width="60"
              :options="chartData[index].options"
              :series="chartData[index].series"
            /> -->
              <div class="progress-wrapper mb-2">
                <b-card-text class="mb-1 mt-1">
                  Avance del Objetivo <strong>{{ objetivo.avance+'%' }}</strong>
                </b-card-text>
                <b-progress
                  :value="`${objetivo.avance}`"
                  max="100"
                  class="progress-bar-secondary"
                  :variant="`success op${index+1}`"
                />
              </div>
            </b-col>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BRow, BCol, BCard, BImg, BCardText, BProgress,
} from 'bootstrap-vue'
//  BFormSelect,
import store from '@/store'
import { $themeColors } from '@themeConfig'
// import VueApexCharts from 'vue-apexcharts'
/* eslint-disable global-require */
const $trackBgColor = '#e9ecef'
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    BCardText,
    BProgress,
    // BFormSelect,
  },
  data() {
    return {
      totalObjetivo: 0,
      totalEntidad: 0,
      totalMedida: 0,
      totalHito: 0,
      totalIndicador: 0,
      avance: 0,
      pendiente: 0,
      dataPie: [],
      items: [],
      itemsPeriodo: [],
      objetivos: [],
      chtClassReport1: null,
      chartOptionsReport1: {
        series: [],
        chart: {
          width: 400,
          type: 'pie',
          events: {},
        },
        labels: [],
        responsive: [{
          breakpoint: 100,
          options: {
            chart: {
              width: 100,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
      },
      modalShow: false,
      titleModal: 'Detalle',
      isBusyModal: false,
      typeAction: 'show',
      chartData: [],
      chartClone: {},
      chartColor: ['#8F5AA0', '#EABA18', '#63BCA6', '#5DB5E5', '#1D924C', '#E84462', '#6463A9', '#E96978', '#F08149'],
      chart: {
        series: [65],
        options: {
          grid: {
            show: false,
            padding: {
              left: -15,
              right: -15,
              top: -12,
              bottom: -15,
            },
          },
          colors: [$themeColors.primary],
          plotOptions: {
            radialBar: {
              hollow: {
                size: '40%',
              },
              track: {
                background: $trackBgColor,
              },
              dataLabels: {
                showOn: 'always',
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  offsetY: 3,
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${parseInt(val)}%`
                  },
                },
              },
            },
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
      selected: null,
      selectedId: 0,
      optionsPeriodo: [
      ],
    }
  },
  mounted() {
    // this.listaObjetivos()
    this.listPeriodo()
  },

  methods: {
    async listaObjetivos() {
      store.dispatch('gsseguimiento/REPORTE_PRINCIPAL', { periodo: this.selectedId, anio: '-1' })
        .then(response => {
          this.items = response
          this.avance = response.avance
          this.pendiente = response.pendiente
          this.totalObjetivo = response.objetivos
          this.totalMedida = response.medidas
          this.totalHito = response.hitos
          this.totalIndicador = response.indicadores
          for (let i = 0; i < response.avanceObjetivo.length; i += 1) {
            const chartClone = JSON.parse(JSON.stringify(this.chart))
            chartClone.options.colors[0] = this.chartColor[i]
            chartClone.series[0] = response.avanceObjetivo[i].avance
            this.chartData.push(chartClone)
          }
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    objetivoDetalle(idMedida) {
      this.$router.push({ name: 'objetivo-detalle', params: { id: idMedida } })
    },
    async listPeriodo() {
      store.dispatch('gsseguimiento/PERIODO_ALL_FIND', { periodo: -1 })
        .then(response => {
          //  { value: null, text: 'PERIODO' }
          for (let i = 0; i < response.length; i += 1) {
            this.optionsPeriodo.push({ value: response[i].periodoId, text: response[i].descripcion })
          }
          this.selected = response[response.length - 1].periodoId
          this.selectedId = response[response.length - 1].periodoId
          this.listaObjetivos()
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
.op1{
  background-color: #8F5AA0 !important;
}
.op2 {
  background-color: #EABA18 !important;
}
.op3 {
  background-color: #63BCA6 !important;
}
.op4 {
  background-color: #5DB5E5 !important;
}
.op5 {
  background-color: #1D924C !important;
}
.op6 {
  background-color: #E84462 !important;
}
.op7 {
  background-color: #6463A9 !important;
}
.op8 {
  background-color: #E96978 !important;
}
.op9 {
  background-color: #F08149 !important;
}

.border-op1 {
  border-color: 1px solid #8F5AA0;
}
.border-left-op2 {
   border-left: 1px solid #EABA18;
}
.border-left-op3 {
  border-left: 1px solid #63BCA6;
}
.border-left-op4 {
   border-left: 1px solid #5DB5E5;
}
.border-left-op5 {
   border-left: 1px solid #1D924C;
}
.border-left-op6 {
   border-left: 1px solid #E84462;
}
.border-left-op7 {
   border-left: 1px solid #6463A9;
}
.border-left-op8 {
   border-left: 1px solid #E96978;
}
.border-left-op9 {
   border-left: 1px solid #F08149;
}

.centrate{
  text-align: center;
}
.card-body{
      padding: 1rem;
}

</style>
